import { Link } from 'react-router-dom';

// Components
import styled from 'styled-components';
import * as S from '../Selecter/Styled';
import * as B from '../Button/Button/Styled';
import cn from 'classnames';

export const City = styled.div`
  font-size: 14px;
  line-height: 1.5em;
  color: var(--grey100);
`;

export const Location = styled.div`
  position: relative;
  margin-left: 2vw;
  text-decoration: none;
  display: flex;
  align-items: center;
  font-family: var(--primary-font), sans-serif;
  font-weight: 600;
  color: var(--grey100);
  width: 120px;

  .icon {
    fill: var(--grey50);
    margin-right: 8px;
    flex-shrink: 0;
  }

  @media (max-width: 767px) {
    display: none;
  }
`;

export const LocationCont = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;

  &:hover {
    ${City} {
      color: var(--theme-palette-brand-color);
    }

    .icon {
      fill: var(--theme-palette-brand-color);
    }
  }
`;

export const Content = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  ${S.List} {
    bottom: auto;
  }

  @media (max-width: 1170px) {
    ${S.List} {
      bottom: auto;
    }

    ${S.IconHolder} {
      margin-right: 0;
    }
  }

  @media (max-width: 767px) {
    flex-wrap: wrap;
    position: static;
  }
`;

export const Panel = styled.div`
  display: flex;
  list-style: none;
  margin: 0 0 0 auto;
  padding-left: var(--panel-padding-left, 3vw);
  align-items: center;

  > div:not(:last-child) {
    margin-right: var(--panel-item-gap, 1.8vw);
  }

  > .insurance:not(:last-child) {
    margin-right: var(--panel-insurance-gap, 1.8vw);
  }

  .icon {
    transition: var(--transition);
  }

  .icon_heart {
    stroke: var(--carbone100);
    stroke-width: 1.7;
    fill: none;
  }

  .icon_cart {
    fill: var(--carbone100);
  }

  .icon_user {
    fill: none;
    font-size: 20px;
    stroke-width: 1.5px;
    stroke: var(--carbone100);
  }

  @media (max-width: 1400px) {
    padding-left: var(--panel-padding-left, 1.5vw);

    > div:not(:last-child) {
      margin-right: var(--panel-item-gap, 1.2vw);
    }

    > .insurance:not(:last-child) {
      margin-right: var(--panel-insurance-gap, 1.2vw);
    }
  }

  @media (max-width: 930px) {
    span {
      display: none;
    }
  }

  @media (max-width: 800px) {
    padding-left: 1vw;
  }

  @media (max-width: 767px) {
    margin-left: auto;
    margin-right: -4px;

    > div:not(:last-child):not(.cart) {
      margin-right: 2vw;
    }

    > .cart {
      margin-right: 0 !important;
    }
  }

  ${B.Button} {
    min-width: 81px;
    padding: 6px 10px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08), 0 2px 7px rgba(0, 0, 0, 0.08);
  }
`;

export const CounterIcon = styled.div`
  position: relative;
  display: inline-block;
  vertical-align: middle;
  margin-right: 0.7vw;

  @media (max-width: 1170px) {
    margin-right: 0;
  }
`;

export const Count = styled.div`
  position: absolute;
  top: -3px;
  right: -7px;
  width: 14px;
  height: 14px;
  background: #f2c94c;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: 1px solid var(--white);
  font-size: 8px;
  font-weight: 600;
  color: var(--black);
`;

export const Label = styled.span`
  @media (max-width: 1170px) {
    display: none;
  }

  html.zoom-lg & {
    @media (max-width: 1960px) {
      display: none;
    }
  }
`;

export const BrandLink = styled(Link)`
  flex-shrink: 0;

  @media (max-width: 320px) {
    max-width: 100px;
  }

  @media (max-width: 767px) {
    img {
      max-width: 100px;
      height: auto;
    }
  }
`;

export const ToggleButton = styled.button`
  width: auto;
  padding: 5px;
  border: none;
  background: none;
  cursor: pointer;
  height: 25px;
  display: none;
  margin-right: 15px;
  margin-left: -5px;

  &:focus {
    outline: none;
  }

  @media (max-width: 767px) {
    display: block;
  }
`;

export const Lines = styled.span`
  position: relative;
  width: 15px;
  height: 2px;
  background: var(--grey100);
  font-size: 0;
  display: block;

  &:before,
  &:after {
    content: '.';
    background: var(--grey100);
    width: 100%;
    position: absolute;
    left: 0;
    right: 0;
    height: 2px;
  }

  &:before {
    top: -5px;
  }

  &:after {
    bottom: -5px;
  }
`;

export const StyledUserLink = styled(Link)`
  color: var(--carbone100);
  text-decoration: none;
  transition: var(--transition);
  white-space: nowrap;
  font-size: 13px;
  display: flex;
  align-items: center;

  &:hover {
    color: var(--theme-palette-links-primary-color-hover);

    .icon_cart {
      fill: var(--theme-palette-links-primary-color-hover);
    }

    .icon_heart,
    .icon_user {
      stroke: var(--theme-palette-links-primary-color-hover);
    }
  }
`;

export const Item = styled.div``;

export const ItemDesktop = styled.div`
  @media (max-width: 767px) {
    display: none;
  }
`;

export const ItemMobile = styled.div`
  display: none;

  @media (max-width: 767px) {
    display: block;
  }
`;

export const Wrapper = styled.div`
  margin-left: auto;
`;

export const Insurance = styled.div`
  max-width: 88px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Header = styled.header.attrs(({ layout }) => ({
  className: cn('header', {
    'is-hidden-search':
      layout === 'home-layout' || layout === 'fullscreen-layout',
    'is-fullscreen': layout === 'fullscreen-layout',
  }),
}))`
  position: relative;
  height: 68px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--white);
  padding: 19px 0;
  border-bottom: 1px solid var(--aluminium35);
  z-index: 3;

  &.is-hidden-search .search {
    display: none !important;
  }

  ${S.TextInner} {
    max-width: 100px;
  }

  @media (max-width: 1000px) {
    &.is-open {
      ${Item} {
        &.favorites {
          display: none;
        }
      }
    }
  }

  @media (min-width: 768px) {
    &.is-fullscreen {
      display: none;
    }
  }

  @media (min-width: 768px) and (max-height: 500px) {
    &.is-fullscreen {
      display: flex !important;
    }
  }

  @media (max-width: 767px) {
    height: auto;
    min-height: 65px;
    padding: 8px 0;

    .btn-stroke {
      display: none;
    }

    .product-layout & {
      border-bottom-color: transparent;
    }

    &.is-open {
      height: 66px;
      min-height: 0;

      ${Location},
      ${Panel},
      ${ToggleButton},
      ${BrandLink} {
        display: none;
      }
    }

    ${S.TextInner} {
      max-width: 85px;
    }
  }
`;
